import axios from "axios";
const actions = {
  getSettingsList(context, id) {
    context.commit("GET_SETTINGS_LIST");
    let getUrl = context.getters.backendServer + "settings/user?id=" + id;
    axios
      .get(getUrl)
      .then(function(response) {
        context.commit("GET_SETTINGS_LIST", response.data);
      })
      .catch(function(e) {
        context.commit("GET_SETTINGS_LIST", e);
        context.dispatch("triggerError", e);
      });
  },
  queryMenuPlanItems(context, id) {
    let getUrl = context.getters.backendServer + "menuplan/allList?user=" + id;
    return axios
      .get(getUrl)
      .then(function(response) {
        return response.data;
      })
      .catch(function(e) {
      });
  },

  queryPreOrderItems(context, id) {
    let getUrl = context.getters.backendServer + "preorder/allList?user=" + id;
    return axios
      .get(getUrl)
      .then(function(response) {
        return response.data;
      })
      .catch(function(e) {
      });
  },
};

export default actions;
